export default "__VITE_ASSET__Bk_2FKHp__"